import { Users, TrendingUp, ShoppingCart } from "lucide-react";

export default function DashboardStats({ summary }) {
  const stats = [
    {
      title: "Unique Visitors",
      value: summary?.total_unique_visitors,
      icon: Users,
      gradient: "from-blue-500 to-blue-600",
    },
    {
      title: "Total Visits",
      value: summary?.total_sessions,
      icon: TrendingUp,
      gradient: "from-purple-500 to-purple-600",
    },
    {
      title: "Buy Clicks",
      value: summary?.total_buy_clicks,
      icon: ShoppingCart,
      gradient: "from-green-500 to-green-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {stats.map(({ title, value, icon: Icon, gradient }) => (
        <div
          key={title}
          className={`bg-gradient-to-br ${gradient} rounded-xl shadow-lg p-6 text-white`}
        >
          <div className="flex items-center mb-4">
            <div className="bg-white bg-opacity-20 p-3 rounded-lg mr-4">
              <Icon className="w-8 h-8" />
            </div>
            <h3 className="text-lg font-semibold">{title}</h3>
          </div>

          <p className="text-5xl font-bold">{value}</p>
        </div>
      ))}
    </div>
  );
}
